import useUpdatePoolTaskSubmissions from '../../../../../hooks/useUpdatePoolTaskSubmissions'
import SharedTelegramTask, {
  Props,
} from '../../../../../shared_components/Missions/Types/Telegram'
import TaskAllocationAmount from '../../../../../shared_components/Missions/TaskAllocationAmount'

export default function TelegramTask(
  props: Omit<Props, 'updateTaskSubmissions' | 'taskAmount'>,
) {
  const updateTaskSubmissions = useUpdatePoolTaskSubmissions()
  return (
    <SharedTelegramTask
      {...props}
      updateTaskSubmissions={updateTaskSubmissions}
      taskAmount={<TaskAllocationAmount taskId={props.taskId} />}
    />
  )
}
